import { extendTailwindMerge } from 'tailwind-merge';

import tailwindConfig from '../tailwind.config';

export default extendTailwindMerge({
  classGroups: {
    'font-size': [{ text: Object.keys(tailwindConfig.theme.fontSize) }]
  }
});
